import { appVersion } from '../data/appVersion'

export const getAppVersion = () => ({ appVersion: appVersion })
